<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts"
    heading-danish="Rangliste - Spontantællinger i alt"
    heading-english="Ranking - Total spontaneous counts"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
